import { HttpClient, HttpHeaderResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { LoaderService } from '../loader.service';
import { Constants } from '../utils/Constants';
import { ResponseHandler } from './response-handler';

@Injectable({
  providedIn: 'root',
})
export class HavApiRequestService {
  BASE_URL = environment.HavBaseUrl;
  constructor(
    private http: HttpClient,
    private loaderService: LoaderService
  ) { }

  executeHttp(method: string, uri: string, body = {}, globalLoader = true, pathParams = {}, optionalHeaders = {}) {
    if (globalLoader) {
      this.loaderService.fireLoaderValue(true);
    }

    uri = this.replacePathParams(uri, pathParams);

    const httpMethods = {
      [Constants.API_METHODS.GET]: () => this.http.get(`${this.BASE_URL}${uri}`, optionalHeaders),
      [Constants.API_METHODS.POST]: () => this.http.post(`${this.BASE_URL}${uri}`, body, optionalHeaders),
      [Constants.API_METHODS.PATCH]: () => this.http.patch(`${this.BASE_URL}${uri}`, body),
      [Constants.API_METHODS.PUT]: () => this.http.put(`${this.BASE_URL}${uri}`, body),
      [Constants.API_METHODS.DELETE]: () => this.http.delete(`${this.BASE_URL}${uri}`, { body }),
      [Constants.API_METHODS.PRESIGNED]: () => this.http.post(`${uri}`, body)
    };

    const request = httpMethods[method.toLocaleLowerCase()]?.();

    return request.pipe(
      map((response) => {
        this.loaderService.isLoading.next(false);
        return response;
      }),
      catchError(err => {
        this.loaderService.isLoading.next(false);
        return throwError(err);
      })
    );
  }

  private replacePathParams(uri: string, pathParams: any): string {
    for (const key in pathParams) {
      if (pathParams.hasOwnProperty(key)) {
        uri = uri.replace(`{${key}}`, pathParams[key]);
      }
    }
    return uri;
  }
}
